import React from 'react';
import { useDrawer } from './Layout';

/**
 * Opens the mobile nav drawer. Rendered inside each page header so it sits in
 * the normal flow — a floating button would need to out-z-index every modal
 * backdrop on the page.
 */
const MenuButton: React.FC = () => {
    const { open } = useDrawer();
    return (
        <button
            type="button"
            onClick={open}
            aria-label="Open menu"
            className="md:hidden w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-lg bg-white/10 border border-white/20 text-white active:bg-white/20 transition-colors"
        >
            <i className="fa-solid fa-bars text-lg"></i>
        </button>
    );
};

export default MenuButton;
